import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/16/solid";

import { HStack, VStack } from "@/components/layout";
import { cx } from "@/utils";
import { formatNumber } from "@/utils/format-number";

const metrics = [
  { label: "Pages processed this month", value: 1675, change: 35 },
  { label: "Transactions processed this month", value: 33761, change: -39 },
  { label: "Hours saved this month", value: 187, change: -41 },
  { label: "Projects created this month", value: 6, change: 23 },
];

export default function MetricsCards() {
  return (
    <div className="grid w-full grid-cols-2 gap-5 xl:w-1/2 2xl:w-1/3">
      {metrics.map((metric, index) => (
        <VStack
          key={index}
          className="h-32 justify-center rounded-lg border bg-white p-4 shadow"
        >
          <div className="text-cp-grey-700 flex-1 text-left text-xs">
            {metric.label}
          </div>
          <HStack className="w-full items-end justify-between">
            <div className="text-4xl font-medium">
              {formatNumber(metric.value)}
            </div>
            <HStack
              className={cx(
                "gap-1 rounded-full px-2 py-1 text-sm font-medium",
                metric.change > 0
                  ? "bg-cp-green-100 text-cp-green-300"
                  : "bg-cp-red-100 text-red-500",
              )}
            >
              {metric.change > 0 ? (
                <ArrowUpIcon className="fill-cp-green-300 h-5 w-4" />
              ) : (
                <ArrowDownIcon className="fill-cp-red-500 l h-5 w-4" />
              )}
              {metric.change}%
            </HStack>
          </HStack>
        </VStack>
      ))}
    </div>
  );
}
